import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getLinkError, isPathOutsideRecoveryLock, isRecoveryLocked } from '@/lib/recoveryLock';

// AUTH-CADASTRO Ato 1 (decisões 3 e 5): com a sessão de recuperação, toda rota trancada vai à tela de nova senha;
// erro de link que cai na página inicial ou no login também vai para lá, com os parâmetros.
export const RecoveryLockGate = () => {
  const location = useLocation();
  const { user } = useAuth();

  if (user && isRecoveryLocked() && !isPathOutsideRecoveryLock(location.pathname)) {
    return <Navigate to="/reset-password" replace />;
  }

  if ((location.pathname === '/' || location.pathname === '/auth') && getLinkError()) {
    return <Navigate to={`/reset-password${location.search}${location.hash}`} replace />;
  }

  return null;
};
